import { API_BASE_URL } from "./config";

export const ensureAbsoluteUrl = (path) => {
  if (!path) return "";
  return path.startsWith("http") ? path : `${API_BASE_URL}/${path}`;
};

export const getTranslation = (translations, languageCode, fallback, field = 'name') => {
  if (!translations || typeof translations !== "object") return fallback;
  if (translations[languageCode] && translations[languageCode][field]) {
    return translations[languageCode][field];
  }
  return fallback; // 🔹 Si no hay traducción, usa el valor original
};
